import { themes } from "./generated-v3";
import { tokens } from "./v3-themes";
import { blue, blueDark } from "@tamagui/colors/legacy";
import { green, greenDark } from "@tamagui/colors/legacy";
import { red, redDark } from "@tamagui/colors/legacy";
import { orange, orangeDark } from "@tamagui/colors/legacy";
import { yellow, yellowDark } from "@tamagui/colors/legacy";
import { pink, pinkDark } from "@tamagui/colors/legacy";
import { purple, purpleDark } from "@tamagui/colors/legacy";
import { gray, grayDark } from "@tamagui/colors/legacy";
export {
  blue,
  blueDark,
  gray,
  grayDark,
  green,
  greenDark,
  orange,
  orangeDark,
  pink,
  pinkDark,
  purple,
  purpleDark,
  red,
  redDark,
  themes,
  tokens,
  yellow,
  yellowDark
};
//# sourceMappingURL=v3.js.map
